import React, { useState } from 'react';
import { ClockIcon, CreditCardIcon, XIcon, ChevronLeftIcon, FilterIcon } from 'lucide-react';
const allAlerts = [{
  id: 1,
  type: 'overdue',
  title: 'Overdue Booking: Home Cleaning Service',
  description: 'Booking #1234 is 2 days overdue',
  time: '2 days ago',
  timestamp: Date.now() - 172800000,
  icon: <ClockIcon size={18} data-id="element-325" />,
  color: 'text-yellow-500 bg-yellow-50'
}, {
  id: 3,
  type: 'payment',
  title: 'Payment Pending Approval',
  description: '$450.00 payment for job #9012 needs approval',
  time: '1 day ago',
  timestamp: Date.now() - 86400000,
  icon: <CreditCardIcon size={18} data-id="element-326" />,
  color: 'text-blue-500 bg-blue-50'
}, {
  id: 4,
  type: 'overdue',
  title: 'Overdue Booking: Plumbing Repair',
  description: 'Booking #2345 is 1 day overdue',
  time: '1 day ago',
  timestamp: Date.now() - 86400000,
  icon: <ClockIcon size={18} data-id="element-327" />,
  color: 'text-yellow-500 bg-yellow-50'
}, {
  id: 5,
  type: 'payment',
  title: 'Payment Pending Verification',
  description: '$280.00 payment for job #3456 needs verification',
  time: '12 hours ago',
  timestamp: Date.now() - 43200000,
  icon: <CreditCardIcon size={18} data-id="element-328" />,
  color: 'text-blue-500 bg-blue-50'
}, {
  id: 7,
  type: 'overdue',
  title: 'Overdue Booking: Electrical Work',
  description: 'Booking #4567 is 3 days overdue',
  time: '3 days ago',
  timestamp: Date.now() - 259200000,
  icon: <ClockIcon size={18} data-id="element-329" />,
  color: 'text-yellow-500 bg-yellow-50'
}, {
  id: 8,
  type: 'payment',
  title: 'Large Payment Pending',
  description: '$1,200.00 payment for job #6789 needs approval',
  time: '6 hours ago',
  timestamp: Date.now() - 21600000,
  icon: <CreditCardIcon size={18} data-id="element-330" />,
  color: 'text-blue-500 bg-blue-50'
}, {
  id: 9,
  type: 'overdue',
  title: 'Overdue Booking: HVAC Service',
  description: 'Booking #8901 is 4 days overdue',
  time: '4 days ago',
  timestamp: Date.now() - 345600000,
  icon: <ClockIcon size={18} data-id="element-331" />,
  color: 'text-yellow-500 bg-yellow-50'
}, {
  id: 10,
  type: 'payment',
  title: 'Payment Pending Review',
  description: '$650.00 payment for job #2345 needs review',
  time: '8 hours ago',
  timestamp: Date.now() - 28800000,
  icon: <CreditCardIcon size={18} data-id="element-332" />,
  color: 'text-blue-500 bg-blue-50'
}];
const AlertItem = ({
  alert
}: {
  alert: (typeof allAlerts)[0];
}) => {
  return <div className="p-4 hover:bg-gray-50 transition-colors duration-150" data-id="element-333">
      <div className="flex items-start" data-id="element-334">
        <div className={`p-2 rounded-md mr-3 ${alert.color}`} data-id="element-335">{alert.icon}</div>
        <div className="flex-1 min-w-0" data-id="element-336">
          <div className="flex justify-between items-start" data-id="element-337">
            <div data-id="element-338">
              <h4 className="text-sm font-medium text-gray-900" data-id="element-339">
                {alert.title}
              </h4>
              <p className="text-sm text-gray-500 mt-0.5" data-id="element-340">
                {alert.description}
              </p>
              <span className="text-xs text-gray-400 mt-1 block" data-id="element-341">
                {alert.time}
              </span>
            </div>
            <button className="text-gray-400 hover:text-gray-500" data-id="element-342">
              <XIcon size={16} data-id="element-343" />
            </button>
          </div>
        </div>
      </div>
      <div className="mt-3 flex space-x-2" data-id="element-344">
        {alert.type === 'payment' && <button className="px-3 py-1 text-xs font-medium rounded-md bg-blue-50 text-blue-600 hover:bg-blue-100" data-id="element-345">
            Approve
          </button>}
        <button className="px-3 py-1 text-xs font-medium rounded-md bg-gray-100 text-gray-600 hover:bg-gray-200" data-id="element-346">
          Details
        </button>
      </div>
    </div>;
};
export function AlertsPage({
  onNavigate
}) {
  const [filterType, setFilterType] = useState<string>('all');
  const [sortOrder, setSortOrder] = useState<'newest' | 'oldest'>('newest');
  const filteredAlerts = allAlerts.filter(alert => filterType === 'all' || alert.type === filterType).sort((a, b) => sortOrder === 'newest' ? b.timestamp - a.timestamp : a.timestamp - b.timestamp);
  return <div className="p-6 h-full flex flex-col" data-id="element-347">
      {/* Header */}
      <div className="mb-6" data-id="element-348">
        <button onClick={() => onNavigate('dashboard')} className="inline-flex items-center text-sm font-medium text-gray-600 hover:text-gray-900 mb-4" data-id="element-349">
          <ChevronLeftIcon size={16} className="mr-1" data-id="element-350" />
          Back to Dashboard
        </button>
        <div className="flex items-center justify-between" data-id="element-351">
          <div data-id="element-352">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-353">All Alerts</h1>
            <p className="text-sm text-gray-500 mt-1" data-id="element-354">
              {filteredAlerts.length} alert
              {filteredAlerts.length !== 1 ? 's' : ''}
            </p>
          </div>
          <div className="flex items-center space-x-3" data-id="element-355">
            <div className="flex items-center space-x-2" data-id="element-356">
              <FilterIcon size={18} className="text-gray-500" data-id="element-357" />
              <select value={filterType} onChange={e => setFilterType(e.target.value)} className="px-3 py-2 text-sm border border-gray-300 rounded-md bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-358">
                <option value="all" data-id="element-359">All Types</option>
                <option value="overdue" data-id="element-360">Overdue</option>
                <option value="payment" data-id="element-361">Payment Pending</option>
              </select>
            </div>
            <select value={sortOrder} onChange={e => setSortOrder(e.target.value as 'newest' | 'oldest')} className="px-3 py-2 text-sm border border-gray-300 rounded-md bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-362">
              <option value="newest" data-id="element-363">Newest First</option>
              <option value="oldest" data-id="element-364">Oldest First</option>
            </select>
          </div>
        </div>
      </div>

      {/* Alerts List */}
      <div className="bg-white rounded-lg shadow border border-gray-100 overflow-hidden flex-1" data-id="element-365">
        {filteredAlerts.length > 0 ? <div className="divide-y divide-gray-200" data-id="element-366">
            {filteredAlerts.map(alert => <AlertItem key={alert.id} alert={alert} data-id="element-367" />)}
          </div> : <div className="p-12 text-center" data-id="element-368">
            <FilterIcon size={48} className="mx-auto text-gray-300 mb-4" data-id="element-369" />
            <h3 className="text-lg font-medium text-gray-900 mb-1" data-id="element-370">
              No alerts found
            </h3>
            <p className="text-sm text-gray-500" data-id="element-371">
              Try adjusting your filter to see more alerts
            </p>
          </div>}
      </div>
    </div>;
}